import type { ProductInventoryItemDto } from '../dto';
import type { IProductInventoryResponseMapper } from './IProductInventoryResponseMapper';

type ProductInventoryResponseShape = {
    data?: unknown;
    items?: unknown;
    content?: unknown;
};

export class ProductInventoryResponseMapper implements IProductInventoryResponseMapper {
    toProductItems(response: unknown): ProductInventoryItemDto[] {
        if (Array.isArray(response)) {
            return response as ProductInventoryItemDto[];
        }

        if (!this.isObject(response)) {
            return [];
        }

        return (
            this.fromDirectCollection(response) ??
            this.fromNestedDataCollection(response) ??
            []
        );
    }

    private fromDirectCollection(
        response: ProductInventoryResponseShape,
    ): ProductInventoryItemDto[] | null {
        if (Array.isArray(response.data)) {
            return response.data as ProductInventoryItemDto[];
        }

        if (Array.isArray(response.items)) {
            return response.items as ProductInventoryItemDto[];
        }

        if (Array.isArray(response.content)) {
            return response.content as ProductInventoryItemDto[];
        }

        return null;
    }

    private fromNestedDataCollection(
        response: ProductInventoryResponseShape,
    ): ProductInventoryItemDto[] | null {
        if (!this.isObject(response.data)) {
            return null;
        }

        const data = response.data as ProductInventoryResponseShape;

        if (Array.isArray(data.data)) {
            return data.data as ProductInventoryItemDto[];
        }

        if (Array.isArray(data.items)) {
            return data.items as ProductInventoryItemDto[];
        }

        if (Array.isArray(data.content)) {
            return data.content as ProductInventoryItemDto[];
        }

        return null;
    }

    private isObject(value: unknown): value is ProductInventoryResponseShape {
        return typeof value === 'object' && value !== null;
    }
}